import { Link } from "@src/components/ui-kit";

interface ProformaLinkProps {
  id: string;
  invoiceNo: string;
}

export const ProformaLink = (props: ProformaLinkProps) => {
  const { id, invoiceNo } = props;

  return (
    <Link
      href={{
        pathname: "/invoices/proforma-invoices/detail",
        query: { id },
      }}
    >
      #{invoiceNo}
    </Link>
  );
};
